(function () {
    const soldOutText = window.variantStrings && window.variantStrings.soldOut ? window.variantStrings.soldOut : 'Sold Out';

    // Sync PDP submit button and mobile clone to match badge text (e.g. when timer flips Coming Soon -> Sold out)
    function syncPdpButtonsFromBadge(badge) {
        if (!badge.id || !badge.id.startsWith('ProductBadge-')) return;
        const section = badge.closest('section');
        if (!section) return;
        const submitBtn = section.querySelector('[data-product-form-submit] span');
        const submitButton = section.querySelector('[data-product-form-submit]');
        if (submitBtn && submitButton?.hasAttribute('disabled')) {
            submitBtn.textContent = badge.textContent.trim();
        }
        const mobileClone = document.querySelector('[data-add-cart-clone]');
        if (mobileClone && mobileClone.classList.contains('sold-out')) {
            mobileClone.textContent = badge.textContent.trim();
        }
    }

    // Reusable function to check a single badge
    function updateBadge(badge, now) {
        const isComingSoon = badge.getAttribute('data-coming-soon') === 'true';
        const endTimeStr = badge.getAttribute('data-badge-end-time');

        // If not coming soon, just ensure text is Sold Out
        if (!isComingSoon) {
            badge.classList.remove('badge--coming-soon');
            badge.innerHTML = soldOutText;
            syncPdpButtonsFromBadge(badge);
            return;
        }

        // If coming soon but no end time, ensure text is Coming Soon
        if (!endTimeStr) {
            badge.classList.add('badge--coming-soon');
            badge.innerHTML = 'Coming Soon';
            syncPdpButtonsFromBadge(badge);
            return;
        }

        // Parse time
        const endTime = Date.parse(endTimeStr);

        if (isNaN(endTime)) {
            return;
        }

        // Debug attributes (kept for inspection in DOM)
        badge.setAttribute('data-current-time', new Date(now).toISOString());
        badge.setAttribute('data-parsed-end-time', new Date(endTime).toISOString());

        if (now >= endTime) {
            // Expired -> Sold Out
            badge.classList.remove('badge--coming-soon');
            badge.setAttribute('data-expired-end-time', endTimeStr);
            badge.innerHTML = soldOutText;
        } else {
            // Active -> Coming Soon
            badge.classList.add('badge--coming-soon');
            badge.innerHTML = 'Coming Soon';
        }
        syncPdpButtonsFromBadge(badge);
    }

    function checkAllBadges() {
        const badges = document.querySelectorAll('[data-badge-end-time], [data-product-badge]');
        const now = new Date().getTime();
        badges.forEach(badge => updateBadge(badge, now));
    }

    // Initialize
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', checkAllBadges);
    } else {
        checkAllBadges();
    }

    // Interval check
    setInterval(checkAllBadges, 60000);

    // Variant Change Listener
    const pubSubAvailable = typeof PUB_SUB_EVENTS !== 'undefined';
    const subscribeAvailable = typeof subscribe !== 'undefined';

    if (pubSubAvailable && subscribeAvailable) {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
            const variant = event.data.variant;
            const sectionId = event.data.sectionId;
            const productBadge = document.querySelector(`#ProductBadge-${sectionId}`);

            if (!productBadge) return;

            if (variant && variant.available) {
                // If variant is available -> Hide Badge
                productBadge.classList.add('hidden');
            } else {
                // If variant is unavailable -> Show Badge and Run Logic
                productBadge.classList.remove('hidden');

                const now = new Date().getTime();
                updateBadge(productBadge, now);
            }
        });
    }
})();
